// src/routes/paths.js
export const paths = {
  landing: '/',
  auth: {
    signin: '/signin',
    signup: '/signup',
    forgotPassword: '/forgotpwd',
    resetPassword: '/change-password'
  },
  legal: {
    privacyPolicy: '/landing/PrivacyPolicy',
    termsOfService: '/landing/TermsOfService'
  },
  dashboard: {
    root: '/dashboard',
    jobs: '/dashboard/jobs',
    applications: '/dashboard/applications',
    applicationsWithJobId: '/dashboard/applications/:jobId',
    reports: '/dashboard/reports',
    reportsWithJobId: '/dashboard/reports/:jobId',
    interviews: '/dashboard/interviews',
    interviewsWithJobId: '/dashboard/interviews/:jobId',
    interviewConfig: '/dashboard/interview-config',
    interviewConfigWithJobId: '/dashboard/interview-config/:jobId',
    rankings: '/dashboard/rankings',
    rankingsWithJobId: '/dashboard/rankings/:jobId',
    screening: '/dashboard/screening',
    screeningWithJobId: '/dashboard/screening/:jobId',
    // users: '/dashboard/users',
    demo: '/dashboard/demo',
    resumePool: '/dashboard/resumePool',
    companies: '/dashboard/companies',
    companyAdmin : '/dashboard/companyAdmin',
    companyUsers: '/dashboard/companyUsers',
  },
  // The Console revamp. Lives alongside the original UI until it reaches parity;
  // at that point these become the root paths and the old ones are removed.
  v1: {
    root: '/v1',
    signin: '/v1/signin',
    signup: '/v1/signup',
    forgotPassword: '/v1/forgotpwd',
    jobs: '/v1/jobs',
    jobConsole: '/v1/jobs/:jobId',
    resumePool: '/v1/resumePool',
    candidate: '/v1/candidate/:jobId/:resumeId',
    resetPassword: '/v1/change-password',
    companies: '/v1/admin/companies',
    companyUsers: '/v1/admin/company',
    allJobs: '/v1/admin/all-jobs',
    allUsers: '/v1/admin/all-users',
  },
  candidate: {
    details: '/candidate/:jobId/:resumeId',
  },
  interview: {
    slot: '/:jobId/:resume_id',
    chat: '/:jobId/:resumeId/chat'
  },
  release :{
    releaseNotes: '/releaseNotes',

  },
  demo: {
    demoPage: '/demo',
  },
  instantInterview: {
    instantInterview: '/instantInterview',
  },
};